import { Icon, IconProps } from '../Icon/Icon';
import { IconName } from '../Icon/icons';
import { InlineMessageIntentType } from './types';

type InlineMessageIconProps = {
  intent?: InlineMessageIntentType;
  customIcon?: IconName;
};

const colorForIntent: Record<InlineMessageIntentType, string> = {
  default: 'text-content-default',
  info: 'text-content-info',
  success: 'text-content-positive',
  warning: 'text-content-warning',
  error: 'text-content-negative',
  neutral: 'text-content-default',
};

export const InlineMessageIcon = ({
  intent = 'default',
  customIcon,
}: InlineMessageIconProps) => {
  if (customIcon) {
    return <Icon name={customIcon} color={colorForIntent[intent]} />;
  }

  const iconForIntent: Record<InlineMessageIntentType, IconProps> = {
    default: {
      name: 'info',
      color: 'text-content-default',
    },
    info: {
      name: 'lightbulb',
      color: 'text-content-info',
    },
    success: {
      name: 'check_circle',
      color: 'text-content-positive',
    },
    warning: {
      name: 'warning',
      color: 'text-content-warning',
    },
    error: {
      name: 'cancel',
      color: 'text-content-negative',
    },
    neutral: {
      name: 'info',
      color: 'text-content-default',
    },
  };

  return <Icon {...iconForIntent[intent]} />;
};

InlineMessageIcon.displayName = 'InlineMessageIcon';
